import LegalDocument from "../../../widgets/legal/LegalDocument";

const BusinessTerms = () => <LegalDocument ns="offer" path="/business-app/terms" />;

export default BusinessTerms;
